const FORM_FIELD_SEPARATOR = '::';

function isValidFormFieldId(formFieldId: string): boolean {
    return Boolean(formFieldId &&
        formFieldId.includes(FORM_FIELD_SEPARATOR) &&
        formFieldId.split(FORM_FIELD_SEPARATOR).length >= 2,
    );
}

export function buildFormFieldId(formId: string, fieldPath: string): string {
    return `${formId}${FORM_FIELD_SEPARATOR}${fieldPath}`;
}

export function getFormIdFromFormFieldId(formFieldId: string): string | null {
    if (!isValidFormFieldId(formFieldId)) {
        return null;
    }
    // formFieldId format: ddrId::requirementType::fieldPath
    // We need to find the last occurrence of FORM_FIELD_SEPARATOR
    const lastSeparatorIndex = formFieldId.lastIndexOf(FORM_FIELD_SEPARATOR);
    if (lastSeparatorIndex === -1) {
        return null;
    }
    return formFieldId.substring(0, lastSeparatorIndex);
}

export function getFieldPathFromFormFieldId(formFieldId: string): string | null {
    if (!isValidFormFieldId(formFieldId)) {
        return null;
    }
    // formFieldId format: ddrId::requirementType::fieldPath
    const lastSeparatorIndex = formFieldId.lastIndexOf(FORM_FIELD_SEPARATOR);
    if (lastSeparatorIndex === -1) {
        return null;
    }
    return formFieldId.substring(lastSeparatorIndex + FORM_FIELD_SEPARATOR.length);
}

export function getRequirementTypeFromFormFieldId(formFieldId: string): string | null {
    if (!isValidFormFieldId(formFieldId)) {
        return null;
    }
    // formFieldId format: ddrId::requirementType::fieldPath
    const parts = formFieldId.split(FORM_FIELD_SEPARATOR);
    if (parts.length < 3) {
        return null;
    }
    // The second part is the requirement type
    return parts[1];
}
